import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Col, Row } from "antd";
import { useSelector } from "react-redux";

import { getLabel } from "../../../hooks/use-labels";

import CouponCard from "./CouponCard";
import SummaryCard from "./SummaryCard";

import DeliveryTypesCard from "../ShoppingCart/CartDetailsView/DeliveryTypesCard";
import DeliveryAddressCard from "../ShoppingCart/CartDetailsView/DeliveryAddressCard";
import ProceedButtonCard from "../ShoppingCart/CartDetailsView/ProceedButtonCard";
import LinkPageHeader from "../../../components/LinkPageHeader";

import OrderModal from "../OrderPayment/PaymentMethodsCard/OrderModal";

const CartSummary = () => {
  const [placeOrder, setPlaceOrder] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { carts, orderInformation } = useSelector((state) => state.order);

  useEffect(() => {
    if (!orderInformation) {
      goBack();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goBack = () => {
    const { link } = location.state || { link: "" };

    navigate(link.path);
  };

  if (placeOrder)
    return (
      <OrderModal onClose={() => setPlaceOrder(false)} transactionIds={[]} />
    );

  if (!orderInformation) return null;

  return (
    <div className="content-container">
      <LinkPageHeader
        className={"cart-page-title"}
        pageTitle={getLabel("myCartLabel")}
      />

      <Row className="cart-details-container" gutter={[20, 20]}>
        <Col lg={17} md={24} sm={24} xs={24} className="gutter-row">
          <DeliveryTypesCard disabled={true} />
          <DeliveryAddressCard disabled={true} />
          <SummaryCard orderInformation={orderInformation} carts={carts} />
        </Col>

        <Col lg={7} md={24} sm={24} xs={24} className="gutter-row">
          <CouponCard goToCart={goBack} />

          <ProceedButtonCard
            summary={true}
            cartItems={carts}
            moveToCart={goBack}
            makeFreePayment={() => setPlaceOrder(true)}
            payableAmount={orderInformation && orderInformation.payableAmount}
          />
        </Col>
      </Row>
    </div>
  );
};

export default CartSummary;
